import * as React from "react";

import {
  DateTimePicker,
  DateTimePickerProps,
} from "@hl/base-components/lib/DateTimePicker";

import { TokenDistributionType } from "apollo/graphql.generated";
import { startOfDay } from "utils/date";

type Props = {
  dateFromProps: DateTimePickerProps;
  dateToProps: DateTimePickerProps;
  distributionType: TokenDistributionType;
  disableStartDate?: boolean;
  disableEndDate?: boolean;
};

export const SaleDatesInput: React.FC<Props> = ({
  dateFromProps,
  dateToProps,
  distributionType,
  disableStartDate,
  disableEndDate,
}) => {
  const isAuction = distributionType === TokenDistributionType.Auction;

  return (
    <>
      {/* Don't show the entire picker, there are some issues where it only disables the dates, but enables the time picker */}
      {!disableStartDate && (
        <DateTimePicker
          label={`${isAuction ? "Auction" : "Mint"} start date`}
          clearable={false}
          {...dateFromProps}
          disabled={disableStartDate}
          minDate={startOfDay()}
        />
      )}
      {!disableEndDate && (
        <DateTimePicker
          clearable={!isAuction}
          label={`${isAuction ? "Auction" : "Mint"} end date`}
          placeholder="None"
          {...dateToProps}
          minDate={startOfDay()}
        />
      )}
    </>
  );
};
